import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the STD Prevention (DoxyPEP) treatment form for Starfish.
 */
export const StarfishStdPreventionTreatment = new TreatmentType({
  id: '4',
  name: ConsultationTreatmentTypes.StdPrevention,
  eligibleTreatmentTypes: [
    {
      id: 3373,
      name: UpsellSlugs.Doxycycline15Treatments,
    },
    {
      id: 3383,
      name: UpsellSlugs.Doxycycline30Treatments,
    },
    {
      id: 3382,
      name: UpsellSlugs.Doxycycline30TreatmentsUpsellFrom15,
    },
  ],
});
